export const statusColors = {
  A: 'var(--green-5)',
  S: 'var(--red-5)',
  L: 'var(--dpurple-5)',
  H: 'var(--yellow-9)',
  N: 'var(--blue-5)',
  U: '#777',
  OR: 'var(--yellow-7)',
};

const statusMap = {
  // Unit States
  AVAILABLE: 'A',
  SOLD: 'S',
  'LEASE UNIT': 'L',
  'ON HOLD': 'H',
  'ON ORDER': 'OR',

  // Condition
  NEW: 'N',
  USED: 'U',
};

// Had to create a function because this data comes up inconsistently
export const getStatus = (state = '') => {
  if (!state) {
    return '';
  }

  return statusMap[state.toUpperCase()] || '';
};
